import { DOCUMENT_PRINT_TYPE } from "@/static/documentPrintTypes";
import { IsArray, IsBoolean, IsEnum, IsOptional, IsString } from "class-validator";
import { Expose, Type } from "class-transformer";
import { DocumentToPrint } from "@/models/api/mail/DocumentToPrint";
import { KSEF_STATUS_ENUM } from "@/static/ksefStatusEnum";

export class Document {
  @IsBoolean()
  @Expose()
  isSelected!: boolean;
  @IsString()
  @Expose()
  documentNumber!: string;
  @IsString()
  @Expose()
  id!: string;
  @IsOptional()
  @Expose()
  lastSendDate!: string;
  @IsString()
  @Expose()
  issuerName!: string;
  @IsBoolean()
  @Expose()
  isCancelled!: boolean;
  @IsEnum(DOCUMENT_PRINT_TYPE)
  @Expose()
  documentPrintType!: DOCUMENT_PRINT_TYPE;
  @IsBoolean()
  @Expose()
  lockChangeType!: boolean;
  @IsArray()
  @Type(() => BookingFile)
  @Expose()
  bookingFiles!: Array<BookingFile>;

  @IsEnum(KSEF_STATUS_ENUM)
  @Expose()
  ksefStatus!: KSEF_STATUS_ENUM;
  @IsString()
  @IsOptional()
  @Expose()
  ksefNumber!: string | null;
  @IsBoolean()
  @Expose()
  canDispatch!: boolean;
  @IsBoolean()
  @Expose()
  isKsefDocument!: boolean;
}

export class DocumentViewModel extends Document {
  copyCount: number;
  constructor(document: Document, copyCount: number) {
    super();
    this.copyCount = copyCount;
    this.isSelected = document.isSelected;
    this.documentNumber = document.documentNumber;
    this.id = document.id;
    this.lastSendDate = document.lastSendDate;
    this.issuerName = document.issuerName;
    this.isCancelled = document.isCancelled;
    this.documentPrintType = document.documentPrintType;
    this.lockChangeType = document.lockChangeType;
    this.bookingFiles = document.bookingFiles;

    this.ksefNumber = document.ksefNumber;
    this.ksefStatus = document.ksefStatus;
    this.canDispatch = document.canDispatch;
    this.isKsefDocument = document.isKsefDocument;
  }

  toDocumentToPrint(): DocumentToPrint {
    const documentToPrint = new DocumentToPrint();
    documentToPrint.id = this.id;
    documentToPrint.copyCount = this.copyCount;
    documentToPrint.documentPrintType = this.documentPrintType;
    return documentToPrint;
  }
}

export class BookingFile {
  @IsString()
  @Expose()
  id!: string;

  @IsString()
  @Expose()
  name!: string;

  @IsBoolean()
  @Expose()
  toSend!: boolean;
}
